import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from './ErrorPage';
export function UnhandledErrorPage() {
    return (_jsx(ErrorPage, { title: _jsx(_Fragment, { children: "Oops! Something went wrong" }), description: _jsx(_Fragment, { children: "We ran into an unexpected issue. Try refreshing the page, or come back a little later." }) }));
}
